import Marquee from "react-fast-marquee";
import { ArrowUpRight } from "lucide-react";

const IMG = "https://static.prod-images.emergentagent.com/jobs/8bd93fc7-3267-4a6a-9a52-abdbe32e8bf0/images";

const CATEGORIES = [
  { label: "Aluminium", accent: "#C0C0C0", image: `${IMG}/e6619440d1e425e0b774d559182f0e7c17034e1639c4ef671f01bf4e2fceb7f9.jpeg` },
  { label: "Copper", accent: "#B87333", image: `${IMG}/58b2c17b76e8fdbcf2f8979627e4377205c0b8c6902c010d39740da05bbe8fba.jpeg` },
  { label: "Solar", accent: "#4A90D9", image: `${IMG}/f2738960bbc444da646ac4807e69cc616bcf7ee8b237756799e5760b79b4f6c5.jpeg` },
  { label: "Lithium", accent: "#9BA8B5", image: `${IMG}/6aa1fbe7195f178090791d3e7bd86b861e574b41a5f1c3447b2530b98f3dd1e0.jpeg` },
  { label: "E-Waste", accent: "#5FB878", image: `${IMG}/a5cee7ca6ffcfa783369c24f11b36697025063d360e25e1079f953b930a59a87.jpeg` },
  { label: "Brass", accent: "#C9A227", image: `${IMG}/5a4a75cb6e3ca6195b68aa7f3c140e80a75496aa4b95be7bb9ea21d8ce3e8367.jpeg` },
  { label: "SS", accent: "#C9D2DA", image: `${IMG}/b7b79d500ebb30b605718e14a5449dca42b62e26599af1d56c43f5468e66c2dc.jpeg` },
  { label: "MS", accent: "#7D8590", image: `${IMG}/5ca8286303a2c6bb12a6df9bef42e16691ff91e3f64d5e741fb7bf3d1296a6bc.jpeg` },
];

export default function CategoryStrip() {
  return (
    <div data-testid="category-strip" className="border-b border-white/10 bg-[#0A0A0A] py-8 overflow-hidden">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {CATEGORIES.map((c) => (
          <a
            key={c.label}
            href="#products"
            data-testid={`category-card-${c.label.toLowerCase().replace(" ", "-")}`}
            className="group relative mx-3 block h-44 w-72 overflow-hidden border border-white/10 hover:border-[#25D366]/70 transition-colors duration-500"
          >
            <img
              src={c.image}
              alt={c.label}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover opacity-70 group-hover:opacity-95 group-hover:scale-110 transition-[opacity,transform] duration-700 ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/95 via-[#0A0A0A]/20 to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-4 flex items-end justify-between">
              <span
                className="font-display font-extrabold uppercase tracking-tight text-xl text-white"
                style={{ textShadow: "0 2px 12px rgba(0,0,0,0.8)" }}
              >
                {c.label}
              </span>
              <ArrowUpRight size={16} className="text-white/50 group-hover:text-[#25D366] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-[color,transform] duration-300" />
            </div>
            <span className="absolute top-3 left-3 h-1.5 w-8" style={{ background: c.accent }} />
          </a>
        ))}
      </Marquee>
    </div>
  );
}
